import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import CollectorLogin from './pages/collector-login';
import MissionListView from './components/MissionListView';
import DutyListView from './components/DutyListView';
import QcMissionsListView from './components/QcMissionsListView';
import ActiveDutiesListView from './components/ActiveDutiesListView';
import MissionLogs from './pages/MissionLogs';
import CollectorsHome from './pages/CollectorsHome';
import UserProtectedWrapper from './pages/UserProtectedWrapper';
import PublicUserWrapper from './pages/PublicUserWrapper';
import { UserContext } from './context/UserContext';
import './App.css';
import { Toaster } from 'react-hot-toast';
import { logout } from './utils/api';

function App() {
  const [currentView, setCurrentView] = useState('duties'); // duties or qc_missions or 'missions' or 'activeDuties'

  const handleLogout = () => {
    logout();
  };

  return (
    <Router>
      <UserContext>
        <div className="App">
          <Toaster position="top-center" reverseOrder={false} timeout={3000} />
          <Routes>
            {/* Public Routes */}
            <Route path="/collector-login" element={
              <PublicUserWrapper>
                <CollectorLogin />
              </PublicUserWrapper>
            } />
            <Route path="/login" element={
              <PublicUserWrapper>
                <Login />
              </PublicUserWrapper>
            } />

            {/* Collector Protected Routes */}
            <Route path="/collectors-home" element={
              <UserProtectedWrapper requiredRole="COLLECTOR">
                <CollectorsHome />
              </UserProtectedWrapper>
            } />

            <Route path="/logs" element={
              <UserProtectedWrapper requiredRole="COLLECTOR">
                <MissionLogs />
              </UserProtectedWrapper>
            } />

            {/* Admin Protected Routes */}
            <Route path="/" element={
              <UserProtectedWrapper requiredRole="ADMIN">
                {currentView === 'duties' && (
                  <DutyListView
                    onLogout={handleLogout}
                    onNavigateActiveDuties={() => setCurrentView('activeDuties')}
                    onNavigateToMissions={() => setCurrentView('missions')}
                  />
                )}
                {currentView === 'activeDuties' && (
                  <ActiveDutiesListView
                    onLogout={handleLogout}
                    onNavigateDuties={() => setCurrentView('duties')}
                    onNavigateToMissions={() => setCurrentView('missions')}
                  />
                )}
                {currentView === 'missions' && (
                  <MissionListView
                    onLogout={handleLogout}
                    onNavigateToQcMissions={() => setCurrentView('qc_missions')}
                    onNavigateToActiveDuties={() => setCurrentView('activeDuties')}
                  />
                )}
                {currentView === 'qc_missions' && (
                  <QcMissionsListView
                    onLogout={handleLogout}
                    onNavigateToMissions={() => setCurrentView('missions')}
                    onNavigateToActiveDuties={() => setCurrentView('activeDuties')}
                  />
                )}
              </UserProtectedWrapper>
            } />

            {/* Catch all - redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </UserContext>
    </Router>
  );
}

export default App;
